import moment from 'moment';

export const DB_DATE_FORMAT = 'YYYY-MM-DD';

export function humanizeDate(rawDate) {
    const m = new moment(rawDate);
    return m.format('DD-MMM-YYYY');
}

export function simpleDate(rawDate) {
    if (rawDate == null) {
        return rawDate;
    }
    const m = new moment(rawDate);
    return m.format('DD-MMM-YYYY');
}


export function isBlank(str) {
    return (str === null || !str || 0 === str.trim().length || /^\s*$/.test(str));
}

export function isArrayEmpty(arr) {
    return (arr.constructor === Array && arr.length === 0)
}

export function isEmpty(obj) {
    if (obj === undefined)
        return true;
    switch (obj.constructor) {
        case (Array): {
            return(obj.length === 0);
        }
        case (Object): {
            return(Object.entries(obj).length === 0);
        }
        case (String): {
            return(obj.trim().length === 0);
        }
        default:
            return false;
    }
}


export function generateUniqueKey() {
    let unique_key = Math.random().toString(16).substring(2, 15) + "-" + Math.random().toString(16).substring(2, 15);
    return unique_key;
}

export const toUrlParams = params => new URLSearchParams(params).toString();

export const isNull = value => value == null || value == undefined;

export const isValidPassword = password => {
    // one lower case, one upper case, one number, one symbol
    const regex = new RegExp("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\\W)");
    return password && password.length >= 8 && regex.test(password);
};

export const booleanAsString = (data) => {
    if (data === true) {
        return 'Yes'
    } else if (data === false) {
        return 'No';
    } else {
        return '';
    }
};

export const anyNull = (...args) => {
    for (let arg of args) {
        if (!arg) return true;
    }
    return false;
};

export const validateEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
